module.exports = __webpack_public_path__ + "static/img/hazard-index-lowres.b7027d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maps/hazard-index-lowres.png
// module id = EXYp
// module chunks = 1